import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-suspend-repair-site',
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatDialogModule,
    MatButtonModule
  ],
  template: `
    <div mat-dialog-title>
      <div class="flex items-center justify-between h-48">
        <h6>Suspend Repair Site</h6>
        <button matIconButton aria-label="Close" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <mat-divider class="mx-20!" />

    <section mat-dialog-content class="flex! flex-col items-center gap-y-20">
      <div class="flex items-center justify-center gap-x-10 text-charcoal mt-20 max-w-[60%]">
        <mat-icon>info_outline</mat-icon>
        <span class="body-2">
          {{ data.companyName }} will be suspended and will no longer be able to receive or action jobs.
        </span>
      </div>

      <mat-form-field>
        <mat-label>Reason</mat-label>
        <input [formControl]="reason" matInput />
      </mat-form-field>
    </section>

    <mat-divider class="mx-20!" />

    <mat-dialog-actions>
      <button matButton="elevated" class="charcoal-button" type="button" mat-dialog-close>CANCEL</button>
      <button matButton="elevated" class="red-button" type="button" (click)="suspend()">SUSPEND</button>
    </mat-dialog-actions>
  `
})
export class SuspendRepairSiteComponent {
  #dialogRef = inject(MatDialogRef<SuspendRepairSiteComponent>);
  data = inject(MAT_DIALOG_DATA);

  reason: FormControl<string> = new FormControl<string>('');

  suspend(): void {
    this.#dialogRef.close({ reason: this.reason.value });
  }
}
